import type { Messages } from './types';
import core from './zh-TW/core';
import simopsRoutes from './zh-TW/simopsRoutes';
import simopsShared from './zh-TW/simopsShared';
import simopsAnalysis from './zh-TW/simopsAnalysis';
import simopsDesignPoints from './zh-TW/simopsDesignPoints';
import simopsDraft from './zh-TW/simopsDraft';
import simopsFiles from './zh-TW/simopsFiles';
import simopsMeshing from './zh-TW/simopsMeshing';
import simopsReport from './zh-TW/simopsReport';
import simopsSolver from './zh-TW/simopsSolver';
import simopsMisc from './zh-TW/simopsMisc';
import simopsNew from './zh-TW/simopsNew';
import meshgen from './zh-TW/meshgen';
import diagnosisRoutes from './zh-TW/diagnosisRoutes';
import diagnosisComponents from './zh-TW/diagnosisComponents';
import auth from './zh-TW/auth';
import compCommon from './zh-TW/compCommon';
import compMesh from './zh-TW/compMesh';
import compAssistant from './zh-TW/compAssistant';
import compProductLibrary from './zh-TW/compProductLibrary';
import compMisc from './zh-TW/compMisc';
import commands from './zh-TW/commands';
import cadmorph from './zh-TW/cadmorph';

/** Traditional Chinese (繁體中文). Typed as Messages → missing keys fail the build. */
const zhTW: Messages = {
  ...core,
  simopsRoutes,
  simopsShared,
  simopsAnalysis,
  simopsDesignPoints,
  simopsDraft,
  simopsFiles,
  simopsMeshing,
  simopsReport,
  simopsSolver,
  simopsMisc,
  simopsNew,
  meshgen,
  diagnosisRoutes,
  diagnosisComponents,
  auth,
  compCommon,
  compMesh,
  compAssistant,
  compProductLibrary,
  compMisc,
  commands,
  cadmorph,
};

export default zhTW;
